// i18n/frArticles.ts

export type FrGender = "m" | "f";
export type ArticleKind = "definite" | "indefinite" | "demonstrative"; // le/la, un/une, ce/cet/cette

export function frArticle(
  kind: ArticleKind,
  gender: FrGender,
  startsWithVowelSound: boolean
): string {
  if (kind === "definite") {
    return startsWithVowelSound ? "l’" : gender === "m" ? "un" : "une";
  }

  if (kind === "indefinite") {
    return gender === "m" ? "un" : "une";
  }

  // demonstrative (ce / cet / cette)
  if (startsWithVowelSound && gender === "m") return "cet";
  return gender === "m" ? "ce" : "cette";
}
